/**
 * @file jump-link.ts
 * @description Общий вид ссылки-перехода в панелях конструктора и вида сайта
 * (phase19.16, QA партии SB122): «Изменить на странице ›», «— изменить ›»,
 * «Открыть «Акции» →», «← К элементу» и подобные. Одно правило высоты на
 * все такие ссылки — 48 px до 1024 (палец), 44 px с 1024, как обычные
 * кнопки (`--control-h`).
 *
 * ```tsx
 * <Link to={href} className={cn(JUMP_LINK_CLASS, "self-start text-sm")}>Открыть ›</Link>
 * ```
 */

/** Ссылка-переход: высота 48 / 44, цвет действия, подчёркивание на наведении, кольцо фокуса. */
export const JUMP_LINK_CLASS =
  "inline-flex min-h-12 items-center rounded-md font-medium text-primary outline-none hover:underline focus-visible:ring-2 focus-visible:ring-ring lg:min-h-11";
